'use client';

import { __extends } from '../../_virtual/_tslib.js';
import Base from './base.js';

var ArrayValidator = /** @class */ (function (_super) {
    __extends(ArrayValidator, _super);
    function ArrayValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrayValidator.prototype.min = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length > limit;
                }
                return false;
            }
        });
        return this;
    };
    ArrayValidator.prototype.max = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length < limit;
                }
                return false;
            }
        });
        return this;
    };
    ArrayValidator.prototype.length = function (limit, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: function (value) {
                if (Array.isArray(value)) {
                    return value.length <= limit;
                }
                return false;
            }
        });
        return this;
    };
    return ArrayValidator;
}(Base));

export { ArrayValidator as default };
//# sourceMappingURL=array.js.map
